import { useContext } from 'react'

import { OptimizelyContext } from '@optimizely/react-sdk'

import { useAuth } from 'routes/Menu/domains/auth'
import Cookies from 'utils/GoustoCookies'
import logger from 'utils/logger'

export const useIsDiscountSofteningEnabled = () => {
  const { isAuthenticated } = useAuth()
  const { optimizely } = useContext(OptimizelyContext)
  let hasAcceptedAnalyticsCookies = false

  try {
    const consentCookieString = Cookies.get('v1_gousto_cookie_consent')
    const consentCookie = consentCookieString ? JSON.parse(consentCookieString) : {}
    hasAcceptedAnalyticsCookies = consentCookie?.categories?.includes('ANALYTICS')
  } catch (error) {
    if (error instanceof Error) {
      ;(logger as any).error(error.message)
    }
  }

  // [BEET-223] - https://gousto.atlassian.net/browse/BEET-223
  // Users are only bucketed into the treatment variation of the experiment if:
  // they have consented to the Analytics cookies AND are not authenticated
  const { enabled, variationKey } =
    optimizely && hasAcceptedAnalyticsCookies && !isAuthenticated
      ? optimizely.decide('beetroots_ofx_discount_softening')
      : { enabled: false, variationKey: undefined }

  const isEnabled = enabled && variationKey === 't1'

  return isEnabled
}
